import {
  faCheck,
  faExclamationTriangle,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useAutosaveContext } from "../../../../hooks";

export default function AutosaveState({
  dataTestIdSaving,
  dataTestIdSaved,
}) {
  const { isSaved, isFormErrors } = useAutosaveContext();

  if (isFormErrors) {
    return (
      <h5 className="text-yellow-400 dark:text-yellow-500 text-xs md:text-sm">
        <FontAwesomeIcon icon={faExclamationTriangle} /> Couldn&#39;t
        autosave. Please check form!
      </h5>
    );
  }

  return (
    <>
      {!isSaved ? (
        <span data-testid={dataTestIdSaving}>
          <FontAwesomeIcon
            icon={faSpinner}
            className="animate-spin"
          />{" "}
          Saving...
        </span>
      ) : (
        <span data-testid={dataTestIdSaved}>
          <FontAwesomeIcon icon={faCheck} /> Saved
        </span>
      )}
    </>
  );
}
